module.exports = __webpack_public_path__ + "static/img/zijianPlat.45f7ee31.jpg";